<template>
    <v-dialog v-model="dialog" max-width="400px" persistent >
        <v-card>
            <v-container>
                <div class="modal__container__div--Btn">
                    <v-btn class="modal__container__btn__close" text @click="closeModal()">
                        <span class="modal__container__btn__close--span" :style="{'color': currentCompany.buttonsColor }" > x </span>                    
                    </v-btn>
                </div>
                <v-card-title class="flex-row-center no-pd-t no-pd-l no-pd-r vdialog_container_cardtile__title"> Você confirma a ativação? </v-card-title>
                <v-card-text class="no-pd">
                    <v-row class="flex-row-center">
                        <v-btn class="text-none menu-btns" :loading="btnLoading" :color="currentCompany.primaryColor" @click="confirm()">
                            <span class="text-white">Sim</span>
                        </v-btn>
                        <v-btn class="text-none menu-btns" outlined :color="currentCompany.primaryColor" @click="closeModal()">Não</v-btn>
                    </v-row>
                </v-card-text>
            </v-container>                           
        </v-card>
    </v-dialog>
</template>

<script>
//Store
import { mapGetters } from "vuex";

//Services
import { activateOfferProductByIdAndCompanyIdAndCurrentContactId } from "@/app/components/offer-detail/service/offer-detail-service";

export default {
    name: 'ConfirmRescueModal',
    computed: {
    ...mapGetters('authenticateStore', {
                currentCompany: 'get_currentCompany',
                isLoggedIn: 'isLoggedIn'
            }
        )
    },
    props: {
        dialog: {
            type: Boolean,
            required: true
        }
    },
    data: () => ({
        btnLoading: false
    }),
    methods: {
        confirm(){
            this.activateDiscount()
        },
        closeModal() {
            this.$emit("closeModal", false);
        },
        activateDiscount(){
            this.btnLoading = true
            activateOfferProductByIdAndCompanyIdAndCurrentContactId(this.currentCompany.id, this.$route.query.offerId)
            .then(() => {
                this.btnLoading = false;
                this.$emit("activatedObj", false);
                this.closeModal()
            })
            .catch( error => {
                error != null ? this.$toasted.show(error.message, { type: 'error' } ) : '' 
                this.btnLoading = false
            })
        }
    }
}
</script>

<style scoped>
.menu-btns{
    margin: 10px;
    width: 100px;
}
</style>